"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ThemeItemType = void 0;
var ThemeItemType;
exports.ThemeItemType = ThemeItemType;

(function (ThemeItemType) {
  ThemeItemType["FontSize"] = "fontSize";
  ThemeItemType["TextAlign"] = "textAlign";
  ThemeItemType["TextFormat"] = "textFormat";
  ThemeItemType["TextColor"] = "textColor";
  ThemeItemType["Font"] = "font";
})(ThemeItemType || (exports.ThemeItemType = ThemeItemType = {}));